/*
 Actions:
 --------
 state.init()
 state.clear()
 From simpleEvents: .on(), .off() and .emit()
 From : .on(), .off() and .emit()

 */
import simpleEvents from "../../_js/simpleevents";
import sizemonitor from "../../_js/state/sizemonitor";
import catastrophe from "../../_js/state/catastrophe";

export default function (defaultState, widget) {

    const state = Object.assign({}, defaultState);
    state.widgetId = widget.widgetId;

    simpleEvents(state);
    sizemonitor(state, widget);
    catastrophe(state, widget);

    state.init = function () {
        state.emit('init');
    };
    state.clear = function () {
        state.emit('clear');
        state.off(); // unbind all events.
    };

    return state;
}
